<template>
  <v-row justify="center" v-if="dialog">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            <v-icon class="mr-2">mdi-cog-box</v-icon>
            Admin Console
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row class="mx-2 mt-2">
          <v-col cols="6">
            <LookupSession @open="openSession" />
            <LookupClient @open="openSession" class="mt-4" />
          </v-col>
          <v-col cols="6">
            <v-card
              flat
              outlined
              class="rounded-10 overflow-y-auto"
              max-height="85vh"
            >
              <v-card-title>
                <v-icon class="mr-2">mdi-history</v-icon>
                Recent Sessions
              </v-card-title>
              <v-card-text>
                <div
                  class="text-center my-10"
                  v-if="recentSessions.length === 0 && !loading"
                >
                  No Recent Sessions
                </div>
                <div
                  class="text-center my-10"
                  v-if="!recentSessions.length > 0 && loading"
                >
                  <LoadingSpinner />
                </div>
                <v-simple-table v-if="recentSessions.length > 0">
                  <thead>
                    <tr>
                      <th>Reference</th>
                      <th>Identity</th>
                      <th>Type</th>
                      <th>Result</th>
                      <th>Kit #</th>
                      <th class="text-right">Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(session, index) in recentSessions"
                      :key="index"
                      @click="openSession(session)"
                      style="cursor: pointer"
                    >
                      <td>
                        <strong>{{ session.reference_number }}</strong>
                      </td>
                      <td>{{ actorName(session) }}</td>
                      <td>{{ session.session_type }}</td>
                      <td>
                        {{ session.score.toPrecision(4) }}
                        <v-chip
                          label
                          x-small
                          color="success"
                          v-if="session.score >= thresholds.PASS"
                        >
                          Pass
                        </v-chip>
                        <v-chip
                          label
                          x-small
                          color="error"
                          v-else-if="session.score < thresholds.CONSIDER_RESCAN"
                        >
                          Fail
                        </v-chip>
                        <v-chip label x-small color="warning" v-else>
                          Warn
                        </v-chip>
                      </td>
                      <td>{{ session.kit_serial_number }}</td>
                      <td class="text-right">
                        {{ session.created_at | luxon({ output: "tz_med" }) }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { prettyIDName } from "@/utils"
import { mapGetters, mapActions } from "vuex"
import { THRESHOLDS } from "@osteon-nexus-connect-lib/nc-frontend"
import LoadingSpinner from "@/components/shared/LoadingSpinner.vue"
import LookupSession from "./AdminConsole/LookupSession.vue"
import LookupClient from "./AdminConsole/LookupClient.vue"

export default {
  name: "AdminConsole",

  components: { LoadingSpinner, LookupSession, LookupClient },

  watch: {
    dialog(value) {
      if (!value) return
      this.fetchRecentSessions()
    },

    search(value, previousValue) {
      if (value != previousValue) this.searched = false
    }
  },

  data() {
    return {
      search: null,
      searched: false,
      recentSessions: [],
      searchResults: [],
      loading: false
    }
  },

  computed: {
    ...mapGetters(["adminDialog"]),

    dialog: {
      get() {
        return this.adminDialog
      },

      set(value) {
        this.setAdminDialog(value)
      }
    },

    thresholds() {
      return THRESHOLDS
    }
  },

  methods: {
    ...mapActions(["setAdminDialog"]),

    actorName(session) {
      return prettyIDName(session.actor_payload)
    },

    async fetchRecentSessions() {
      this.loading = true
      const response = await this.$axios.get("/proxy/admin/sessions/")
      this.recentSessions = response.data
      this.loading = false
    },

    openSession(session) {
      this.$emit("open", session)
      this.dialog = false
    }
  }
}
</script>
